import { render, staticRenderFns } from "./instructTemplate.vue?vue&type=template&id=dd8eba42&"
import script from "./instructTemplate.vue?vue&type=script&lang=js&"
export * from "./instructTemplate.vue?vue&type=script&lang=js&"
import style0 from "./instructTemplate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\svn\\家用后台\\branches\\20240430-1.5.0\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dd8eba42')) {
      api.createRecord('dd8eba42', component.options)
    } else {
      api.reload('dd8eba42', component.options)
    }
    module.hot.accept("./instructTemplate.vue?vue&type=template&id=dd8eba42&", function () {
      api.rerender('dd8eba42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/instruct/instructTemplate.vue"
export default component.exports